import { supportedLanguagesLabels } from "./language"

export const getFormattedLanguage = (title: string) => {
  return supportedLanguagesLabels.get(title) || title
}
